/* 🤖 this file was generated by svg-to-ts */
export const iconFood2: {
  name: 'food_2';
  data: string;
} = {
  name: 'food_2',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M5.293.293a.999.999 0 011.414 0L8 1.586 9.293.293a.999.999 0 011.414 0L12 1.586 13.292.294A1 1 0 0115 1v13c0 1.141-.86 2-2 2H3c-1.14 0-2-.859-2-2V1a1.006 1.006 0 01.618-.923 1.001 1.001 0 011.09.217L4 1.586zM13 12H3v2h10v-2zm0-4H3v2h10V8zm-3-5.586L8.707 3.707a.999.999 0 01-1.414 0L6 2.414 4.707 3.707a.999.999 0 01-1.414 0L3 3.414V6h10V3.414l-.293.293a.997.997 0 01-1.414 0L10 2.414z" fill-rule="evenodd"/></svg>`,
};
